import styled from '@emotion/styled';
import {Wws_WeddingWebsiteV2} from '../../../../../types/graphql';
import RegistryButton from '../../../../RegistryButton';
import {themeFont} from '../../../../../lib/themeFont';
import {useRegistryContext} from '../../../../../context/RegistryContext';
import RegistryPreview from '../../../../RegistryPreview';
import {cleanHTMLInput} from "../../../../../lib/cleanUserInput";

const RegistrySectionWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 40px;
`;

const RegistryNote = styled('div')`
  ${themeFont('s6')}
  padding: 0 48px;
`;

const RegistryPreviewWrapper = styled('div')`
  max-width: 600px;
`;

export interface SinglePageDesktopRegistrySectionProps {
  weddingWebsiteResult: Wws_WeddingWebsiteV2;
}

const SinglePageDesktopRegistrySection = ({
                                            weddingWebsiteResult,
                                          }: SinglePageDesktopRegistrySectionProps) => {
  const {registryItems} = useRegistryContext();
  const note = weddingWebsiteResult?.registryNote;

  return (
    <RegistrySectionWrapper>
      {!!note && (
        <RegistryNote
          dangerouslySetInnerHTML={{__html: cleanHTMLInput(note)}}
          data-testid="RegistrySection__Note"
        />
      )}
      <RegistryPreviewWrapper>
        <RegistryPreview registryItems={registryItems || []}/>
      </RegistryPreviewWrapper>
      <RegistryButton/>
    </RegistrySectionWrapper>
  );
};

export default SinglePageDesktopRegistrySection;
